var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-row",class:{ 'record-strip': _vm.strip, [`record-${_vm.tone}`]: _vm.tone }},[_c('div',{staticClass:"record-cells"},[_vm._t("default")],2),(_vm.$scopedSlots.note)?_c('div',{staticClass:"record-note"},[_vm._t("note")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }